
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { featuredCreatorsSelector, fetchFeaturedCreators } from '../../../LandingPage/LandingPage.duck';
import { CarouselSection, IconCollection } from '../../../../components';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { createResourceLocatorString } from '../../../../util/routes';
import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';
import { CREATOR_SEARCH_ID, USER_TYPE_AUDIENCE } from '../../../../constants';
import { getUserType } from '../../../../util/data';

const FeaturedCreators = ({ sectionName, description, currentUser }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const routeConfiguration = useRouteConfiguration();
    const featuredCreators = useSelector(featuredCreatorsSelector);

    const userType = getUserType(currentUser);
    // if (userType !== USER_TYPE_AUDIENCE) return null;
    
    useEffect(() => {
        dispatch(fetchFeaturedCreators());
    }, []);

    const showMoreFilms = () => {
        history.push(
            createResourceLocatorString(
                'CreatorLandingPage',
                routeConfiguration,
                {}
            )
        );
    };

    const linkprops = (userType === USER_TYPE_AUDIENCE)
        ? { name: 'AudienceProfileSettingsPage', params: { userType: USER_TYPE_AUDIENCE } }
        : null;

    const emptyCardDataMaybe = userType === USER_TYPE_AUDIENCE
        ? { emptyCardData: { icon: <IconCollection icon="icon-film" />, title: 'creators Wanted', text: 'Become A Creator And Start Earning', linkprops } }
        : {};

    return featuredCreators?.length ? (
        <CarouselSection
            name={sectionName}
            description={description}
            items={featuredCreators}
            handleAction={showMoreFilms}
            {...emptyCardDataMaybe}
        />
    ) : null;
};

export default FeaturedCreators;
